import React, {Component} from 'react';
import h from 'react-hyperscript';
import './BarCharts.scss';
import {unMountD3} from 'Src/utils/utils';
import * as d3 from 'd3';

class BarChartHorizontal extends Component {
  constructor(props) {
    super(props);
    this.createBarChartHorizontal = this.createBarChartHorizontal.bind(this);
    this.yMargin = 27;
    this.offsetLeft = 124;
    this.offsetTop = 32;

    this.barChartRef = React.createRef();
  }

  componentDidMount() {
    this.createBarChartHorizontal();

    const setRef = this.props.setRef;

    if (setRef) {
      setRef(this.barChartRef);
    }
  }

  componentWillUnmount() {
    unMountD3(this.node, d3);
  }

  componentDidUpdate(prevProps) {
    const updateGraph = prevProps.size[0] !== this.props.size[0];

    if (updateGraph) {
      this.updateGraph();
    }
  }

  get width() {
    return this.props.size[0];
  }

  get barHeight() {
    return this.props.barHeight + this.yMargin;
  }

  get height() {
    return this.barHeight * this.props.data.length;
  }

  removeGraphElements() {
    d3.select(this.node).selectAll('*').remove();
  }

  updateGraph() {
    this.removeGraphElements();
    this.createBarChartHorizontal();
  }

  createBarChartHorizontal() {
    const node = this.node;
    const ticks = [0, .25, .5, .75, 1];
    const formatPercent = d3.format('.0%');
    const dynamicGraphSize = this.props.dynamicGraphSize;
    const xMargin = this.width * (dynamicGraphSize ? .235 : .195);

    const scale = d3.scaleLinear()
        .domain([0, d3.max(this.props.data, (d) => 1)])
        .range([0, this.width - xMargin]);

    d3.line().x( (d) => {
      return d.value;
    });

    const makeXGridLines = () => {
      return d3.axisBottom(scale).tickValues(ticks);
    };

    const xAxis = d3.axisBottom()
        .scale(scale)
        .tickValues(ticks)
        .tickFormat(formatPercent);

    const svg = d3.select(node);

    svg.append('g')
        .attr('class', 'grid')
        .attr('transform', `translate(${this.offsetLeft}, ${this.height + 10})`)
        .call(
            makeXGridLines()
                .tickSize(-this.height)
                .tickFormat('')
        );

    svg.append('g')
        .call(xAxis)
        .attr('class', 'x-axis')
        .attr('transform', `translate(
          ${this.offsetLeft}, ${this.height + 10}
        )`);

    const g = svg.selectAll('.bar')
        .data(this.props.data)
        .enter()
        .append('g')
        .attr('class', 'bar')
        .attr('height', 40)
        .attr('transform', (d, i) => {
          const translateX = this.offsetLeft;
          const translateY = i * this.barHeight + this.offsetTop;
          return `translate(${translateX}, ${translateY})`;
        });

    g.append('rect')
        .attr('height', this.barHeight - this.yMargin)
        .attr('y', -this.barHeight/4)
        .attr('width', (d) => scale(d.value))
        .attr('fill', this.props.color);

    g.append('text')
        .attr('x', (d) => scale(1) + 8)
        .attr('alignment-baseline', 'central')
        .attr('dy', '.35em')
        .attr('class', 'graph__label--value')
        .text((d) => d.valueFormatted);

    g.append('text')
        .attr('x', -this.offsetLeft)
        .attr('alignment-baseline', 'central')
        .attr('width', this.offsetLeft)
        .attr('dy', '.35em')
        .attr('class', 'graph__label--value eyebrow')
        .text((d) => d.name)
        .call(this.wrap, 100);
  }

  wrap(text, width) {
    text.each(function() {
      // eslint-disable-next-line no-invalid-this
      const text = d3.select(this);
      const words = text.text().split(/\s+/).reverse();
      let word;
      let line = [];
      let lineNumber = 0;
      const lineHeight = 1;
      const x = text.attr('x');
      const y = text.attr('y');
      const dy = 0;
      let tspan = text.text(null)
          .append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dy', dy + 'em');

      // eslint-disable-next-line
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(' '));
          line = [word];
          tspan = text.append('tspan')
              .attr('x', x)
              .attr('y', y)
              .attr('dy', ++lineNumber * lineHeight + dy + 'em')
              .text(word);
        }
      }
    });
  }

  render() {
    return (
      h('div', {
        className: 'chart bar-chart__container',
        id: this.props.id,
        ref: this.barChartRef,
      },
      h('svg', {
        ref: (node) => this.node = node,
        width: this.width,
        height: this.height + 50,
      })
      )
    );
  }
}

export default BarChartHorizontal;
